module.exports = __webpack_public_path__ + "img/3_1.9d27a92d.png";